import React, { useEffect, useMemo, useState, useCallback } from 'react';
import { Tooltip, Dropdown, Divider } from 'antd';
import classnames from 'classnames';
import { idIsTreadMail } from '@web-common/utils/utils';
import IconCard from '@web-common/components/UI/IconCard';
import LoadingOutlined from '@ant-design/icons/LoadingOutlined';
import useDebounceForEvent from '@web-mail/hooks/useDebounceForEvent';
import MailMenuRender from '../MailMenuRender/MailMenuRender';
import { MAIL_MENU_ITEM } from '../../../constant';
import { timeOutRequest } from '../util';
import useCreateCallbackForEvent from '@web-mail/hooks/useCreateCallbackForEvent';
import { getMailFromMails, trans2DomPropsObj } from '@web-mail/util';
const MailMenuIconRender = props => {
    const { data = [], mailData, menuType = 'icon', menuItemStateMap, onMenuItemStateChange, beforeMenuClick, theme, domProps } = props;
    const [_localData, _setLocalData] = useState([]);
    const [groupLineMap, setGroupLineMap] = useState(new Map());
    const [menuVisiable, setMenuVisiable] = useState({});
    const getDomPropsObject = useCreateCallbackForEvent((mails, menuConfig) => {
        return trans2DomPropsObj(domProps, mails, menuConfig);
    });
    useEffect(() => {
        const list = [];
        const map = new Map();
        const defaultList = [];
        groupLineMap.clear();
        data.forEach(item => {
            const groupName = item.group ? item.group : undefined;
            const groupList = map.get(groupName);
            const show = typeof item.show === 'function' ? item.show : () => item.show;
            if (groupList) {
                if (show(mailData)) {
                    groupList.push(item);
                }
            }
            else if (show(mailData)) {
                map.set(item.group, [item]);
            }
        });
        for (const _list of map.entries()) {
            const [key, value] = _list;
            if (key === undefined) {
                defaultList.push(...value);
            }
            else {
                list.push(...value);
                if (value && value.length) {
                    groupLineMap.set(value[value.length - 1], true);
                }
            }
        }
        const resList = [...list, ...defaultList];
        if (groupLineMap.get(resList[resList.length - 1])) {
            groupLineMap.delete(resList[resList.length - 1]);
        }
        setGroupLineMap(groupLineMap);
        _setLocalData(resList);
    }, [data, mailData]);
    const handleMenuItemClick = useCallback((item) => {
        if (item.onClick) {
            try {
                if (beforeMenuClick) {
                    beforeMenuClick(item, mailData);
                }
            }
            catch (e) {
                console.error('[error handleMenuItemClick beforeMenuClick]', e);
            }
            let task = item.onClick(mailData);
            if (task === null || task === void 0 ? void 0 : task.then) {
                try {
                    task = timeOutRequest(task, 15000);
                    onMenuItemStateChange && onMenuItemStateChange(item.key + '', true);
                    task === null || task === void 0 ? void 0 : task.finally(() => {
                        onMenuItemStateChange && onMenuItemStateChange(item.key + '', false);
                    });
                }
                catch (e) {
                    console.error('[MailMenuIconRender syncMenu Error]:', e);
                    onMenuItemStateChange && onMenuItemStateChange(item.key + '', false);
                }
            }
        }
    }, [onMenuItemStateChange, mailData]);
    const dbHandleMenuItemClick = useDebounceForEvent(handleMenuItemClick, 500, {
        leading: true,
        trailing: false,
        maxWait: 500,
    });
    const getElement = useCallback((params) => {
        if (typeof params === 'function') {
            return params(mailData);
        }
        return params;
    }, [mailData]);
    const getGroupLineCom = useCallback((config) => false &&
        (groupLineMap.has(config) ? (React.createElement("div", { className: "u-tool-line" },
            React.createElement("div", { className: "line" }))) : null), [groupLineMap]);
    const getBaseMenuIconCom = useCallback((config) => {
        var _a;
        let element;
        const onlyUnfold = !!config.onlyUnfold;
        const isOpen = config.key && menuVisiable[config.key];
        let isOnly = !onlyUnfold;
        const isBack = config.key === 'BACK';
        let showCount = 0;
        if (Array.isArray(config.subMenus)) {
            config.subMenus.forEach(item => {
                const show = typeof item.show === 'function' ? item.show : () => item.show;
                if (show(mailData)) {
                    showCount += 1;
                }
            });
        }
        const mail = getMailFromMails(mailData);
        const mailMenuConfig = menuItemStateMap && menuItemStateMap[(_a = mail === null || mail === void 0 ? void 0 : mail.entry) === null || _a === void 0 ? void 0 : _a.id];
        const domPropsObj = getDomPropsObject(mailData, config);
        const isLoading = !!(mailMenuConfig && mailMenuConfig[(config === null || config === void 0 ? void 0 : config.key) + '']);
        if (Array.isArray(config.subMenus) && showCount == 0) {
            return null;
        }
        isOnly = showCount <= 1;
        if (config.key === MAIL_MENU_ITEM.LOCAL_MAIL_IMPORT) {
            element = config.render && config.render(mailData);
        }
        else {
            element =
                menuType === 'text' ? (React.createElement("div", Object.assign({ className: classnames('u-tool-btn-text', 'u-tool-btn-text-white', theme == 'light' ? 'u-tool-btn-text-white' : 'u-tool-btn-text-gray', isOpen ? 'u-tool-btn-text-open' : '') }, domPropsObj),
                    React.createElement("div", { className: config.subMenus && !onlyUnfold && !isOnly ? 'u-tool-btn-text-left' : 'u-tool-btn-text-center', onClick: e => {
                            if (!config.subMenus || !onlyUnfold) {
                                if (!isLoading) {
                                    dbHandleMenuItemClick(config);
                                }
                            }
                            if (config.subMenus && !onlyUnfold) {
                                e.stopPropagation();
                            }
                        }, style: isLoading ? { color: 'gray', cursor: 'not-allowed', display: 'flex' } : {} },
                        isLoading ? (React.createElement("div", { style: { marginRight: 10 } },
                            React.createElement(LoadingOutlined, { style: { fontSize: '12px' } }))) : null,
                        config.icon && React.createElement("div", { className: "u-tool-btn-text-back" }, getElement(config.icon)),
                        getElement(config.name),
                        onlyUnfold && (React.createElement("div", { className: "u-tool-btn-text-icon" },
                            React.createElement(IconCard, { type: "arrowDown", stroke: isOpen ? '#386ee7' : '#A8AAAD' })))),
                    config.subMenus && !onlyUnfold && !isOnly && (React.createElement(React.Fragment, null,
                        React.createElement(Divider, { type: "vertical" }),
                        React.createElement("div", { className: "u-tool-btn-text-right" },
                            React.createElement(IconCard, { type: "arrowDown", stroke: isOpen ? '#386ee7' : '#A8AAAD' })))))) : (React.createElement("div", Object.assign({ className: "dark-svg-invert u-tool-btn", onClick: e => {
                        if (!config.subMenus) {
                            if (!isLoading) {
                                dbHandleMenuItemClick(config);
                            }
                        }
                    }, style: isLoading ? { cursor: 'not-allowed', backgroundColor: 'f4f4f5' } : {} }, domPropsObj), isLoading ? React.createElement(LoadingOutlined, { width: 28, style: { fontSize: '16px', width: 28, height: 28 } }) : getElement(config.icon)));
        }
        let tooltip;
        if (typeof config.tooltip === 'function') {
            try {
                tooltip = config.tooltip() || config.name;
            }
            catch (e) {
                console.error('[MailMenuIconRender config.tooltip Error]:', e);
            }
        }
        else {
            tooltip = config.tooltip !== undefined && config.tooltip != null ? config.tooltip : config.name;
        }
        return tooltip && menuType !== 'text' ? (React.createElement(Tooltip, { placement: "bottom", title: getElement(tooltip), mouseEnterDelay: 0.3, mouseLeaveDelay: 0.15 }, element)) : (element);
    }, [getElement, menuVisiable, setMenuVisiable, mailData, menuItemStateMap, onMenuItemStateChange, theme]);
    const beforeMenuClickRef = useCreateCallbackForEvent(beforeMenuClick);
    const getSubMenuItem = useCallback((config) => {
        if (typeof config === 'function') {
            return config(mailData);
        }
        return (React.createElement(MailMenuRender, { beforeMenuClick: beforeMenuClickRef, menuItemStateMap: menuItemStateMap, onMenuItemStateChange: onMenuItemStateChange, mailData: mailData, data: config, onMenuClick: () => setMenuVisiable({}), domProps: domProps }));
    }, [mailData, menuItemStateMap, onMenuItemStateChange, domProps]);
    const getMenuItem = useCallback((item, index) => (React.createElement(React.Fragment, { key: index },
        getBaseMenuIconCom(item),
        getGroupLineCom(item))), [mailData, getBaseMenuIconCom, menuItemStateMap]);
    const getSubMenu = useCallback((config) => {
        const element = getBaseMenuIconCom(config);
        if (element) {
            return (React.createElement(React.Fragment, null,
                React.createElement(Dropdown, { overlayClassName: "u-tree-dropmenu", overlay: React.createElement(React.Fragment, null, config.subMenus ? getSubMenuItem(config.subMenus) : null), trigger: ['click'], placement: "bottomLeft", visible: !!menuVisiable[config.key + ''], onVisibleChange: visible => {
                        if (config.onClick) {
                            setMenuVisiable(map => ({
                                [config.key + '']: visible,
                            }));
                            return false;
                        }
                        setMenuVisiable(map => ({
                            [config.key + '']: visible,
                        }));
                    } }, element),
                getGroupLineCom(config)));
        }
        return null;
    }, [getSubMenuItem, getMenuItem, mailData, menuVisiable, setMenuVisiable, getBaseMenuIconCom]);
    const getCouldShowMenu = useCallback((data) => data.filter(item => {
        const { show = true } = item;
        if (typeof show === 'function') {
            if (mailData) {
                return show(mailData);
            }
            return false;
        }
        return show;
    }), [mailData]);
    const menuElement = useMemo(() => {
        const mail = getMailFromMails(mailData);
        return mail ? (React.createElement("div", { className: classnames('u-tool', idIsTreadMail(mail === null || mail === void 0 ? void 0 : mail.id) ? 'u-tool-tread' : '') }, getCouldShowMenu(_localData).map((item, index) => {
            if (item.subMenus) {
                return getSubMenu(item);
            }
            return getMenuItem(item, index);
        }))) : (React.createElement(React.Fragment, null));
    }, [_localData, mailData, menuVisiable, menuItemStateMap, onMenuItemStateChange]);
    return menuElement;
};
export default MailMenuIconRender;
